import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getGlobalParamFilterListEndpoint } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getGlobalParamFilterList = createApi(
  getGlobalParamFilterListEndpoint,
  "POST"
);

const globalParamFilterSlice = createSlice({
  name: "globalParamFilter",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGlobalParamFilterList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGlobalParamFilterList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGlobalParamFilterList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default globalParamFilterSlice.reducer;